export default __webpack_public_path__ + "d05452388d0829529113dcd1688d4bd0.png";